import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import compose from 'recompose/compose';
import ReactRouterPropTypes from 'react-router-prop-types';

import { withStyles } from 'material-ui/styles';

import { fetchResins } from '../../actions'
import { getHost } from '../../constants/themes';
import AddLayer from './AddLayer';
import EditLayer from './EditLayer';
import StartNew from './StartNew';
import Viewer from './Viewer';
import Settings from './Settings';
import Report from './Report';

const styles = () =>({
  root: {
    height: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
  },
});

export class StackupDesign extends Component {
  componentDidMount(){
    const host = getHost();
    const { fetchResins } = this.props;
    console.log('host:', host); // eslint-disable-line no-console
    fetchResins(host);
  }

  render() {
    const { classes, match } = this.props;

    return (
      <div className={classes.root} data-title="Stackup Design">
        <Switch>
          <Route exact path={`${match.url}/new`} component={StartNew} />
          <Route exact path={`${match.url}/layers/new`} component={AddLayer} />
          <Route exact path={`${match.url}/layers/:key/edit`} component={EditLayer} />
          <Route exact path={`${match.url}/settings`} component={Settings} />
          <Route exact path={`${match.url}/report`} component={Report} />
          <Route path={`${match.url}/`} component={Viewer} />
        </Switch>
      </div>
    );
  }
}

StackupDesign.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  classes: PropTypes.shape({ 
    root: PropTypes.string
  }).isRequired,
  fetchResins: PropTypes.func.isRequired
};

export default compose(
  connect(null, { fetchResins }),
  withStyles(styles)
)(StackupDesign);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/index.js